import { render, staticRenderFns } from "./VisaoGeral.vue?vue&type=template&id=cb33aacc&scoped=true&"
import script from "./VisaoGeral.vue?vue&type=script&lang=js&"
export * from "./VisaoGeral.vue?vue&type=script&lang=js&"
import style0 from "./VisaoGeral.vue?vue&type=style&index=0&id=cb33aacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb33aacc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb33aacc')) {
      api.createRecord('cb33aacc', component.options)
    } else {
      api.reload('cb33aacc', component.options)
    }
    module.hot.accept("./VisaoGeral.vue?vue&type=template&id=cb33aacc&scoped=true&", function () {
      api.rerender('cb33aacc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/VisaoGeral/VisaoGeral.vue"
export default component.exports